import path, { join } from 'node:path';
import type { ComponentGenerationResult } from '@wix/gena';
import { componentGenerator } from '@wix/gena';
import { BACKEND_DIR, getApiFolder } from '@wix/cli-app-definitions';

const API_TEMPLATE = path.resolve(__dirname, '../templates/api');
const WEB_METHOD_TEMPLATE = path.resolve(__dirname, '../templates/web-method');

export async function generateApi(
  projectFolder: string,
  folderName: string
): Promise<ComponentGenerationResult> {
  const cwd = path.join(getApiFolder(projectFolder), folderName);

  return await componentGenerator({
    template: API_TEMPLATE,
    cwd,
    projectFolder,
    data: {
      folderName,
    },
  });
}

export async function generateWebMethod(
  projectFolder: string,
  folderPath: string
): Promise<ComponentGenerationResult> {
  const filePath = join(BACKEND_DIR, folderPath);

  return await componentGenerator({
    template: WEB_METHOD_TEMPLATE,
    cwd: projectFolder,
    projectFolder,
    data: {
      filePath,
      fileName: path.basename(filePath),
    },
  });
}
